import { MarketplaceCronSettingDetailPage } from "@/features/marketplace-cron/pages/MarketplaceCronSettingDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/marketplace-automation/$jobKey")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["marketplace_campaigns.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: MarketplaceCronSettingDetailPage,
});
